import { IServicePackage } from '../../types/reducers/publishTerms';
import { createSelector } from 'reselect';
import { selectPublishTerms } from './selectPublishTerms';
import { IAppState } from '../../../AppModulesWrapper';

// @deprecated Используется только для обратной совместимости с ручкой публикации
export const selectActivePackage = createSelector(
  (state: IAppState) => selectPublishTerms(state),
  ({ packages, selectedPackageId }): IServicePackage | null => {
    if (!selectedPackageId) {
      return null;
    }

    return packages[selectedPackageId];
  },
);
